// @flow
import { APIVersion } from './apiVersion';

export default APIVersion.v4;



// WEBPACK FOOTER //
// ../utilities/apiDefault.js